import {
  IonSpinner,
} from '@ionic/react';
import './styles.css';

const Spinner: React.FC = () => {
  return (
    <div className="spinner-wrapper">
      <IonSpinner />
    </div>
  );
};

export default Spinner;